module.exports = __webpack_public_path__ + "media/images/icons/footer-flourish-0453fcf1a45c666cb5c5aee3cc1cb20c.svg";